@if (addBackgroundMap()) {
  <div class="button-with-map">
    <img [ngSrc]="mapUrl()" alt="karta knapp bakgrund" height="96" width="220">
    <div class="overlay"></div>
    @if (iconOnly() === true) {
      <app-ui-icon-button
        #openMapButtonWithMapIconOnly
        (onClick)="processClick()"
        [color]="iconButtonColor()"
        [disabled]="false"
        [icon]="'map'"
        [size]="iconButtonSize()"
      >
      </app-ui-icon-button>
    } @else {
      <app-ui-button
        #openMapButtonWithMap
        (onClick)="processClick()"
        [color]="color()"
        [disabled]="false"
        [expanded]="expanded()"
        [size]="size()"
      >
        <app-ui-icon name="map"></app-ui-icon>
        Visa på karta
      </app-ui-button>
    }
  </div>
} @else {
  @if (iconOnly() === true) {
    <app-ui-button
      #openMapButtonWithoutMapIconOnly
      (onClick)="processClick()"
      [color]="color()"
      [disabled]="false"
      [expanded]="expanded()"
      [ngClass]="{ 'icon-only': iconOnly() }"
      [size]="size()"
    >
      <app-ui-icon name="map"></app-ui-icon>
    </app-ui-button>
  } @else {
    <app-ui-button
      #openMapButtonWithoutMap
      (onClick)="processClick()"
      [color]="color()"
      [disabled]="false"
      [expanded]="expanded()"
      [size]="size()"
    >
      <app-ui-icon name="map"></app-ui-icon>
      Visa på karta
    </app-ui-button>
  }
}



